var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -0.10000000000000853 960.6 264.50000000000006",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 689,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.2 0v204l26.2.1V107h63.3V81.3h-63.3V25.7h82.4V0zM388.1 41.4c9.5 0 17.1-7.7 17.1-17.1s-7.7-17.1-17.1-17.1c-9.5 0-17.1 7.7-17.1 17.1s7.7 17.1 17.1 17.1zM374.8 67.1V204H401V67.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M498.3 63.1c-34.9 0-59.2 29.5-59.2 64.5s24.3 64.5 59.2 64.5c16 0 29.1-6.2 38.7-16.2V194c0 22.7-17.8 41.6-41.1 41.6-8.4 0-16.7-3.2-23.3-7.8l-13.2 22.8c10.5 6.8 23 10.7 36.4 10.7 37.2 0 67.3-30.1 67.3-67.3V67.1H537v12.2c-9.6-10-22.7-16.2-38.7-16.2zm-32.9 64.5c0-21.7 16.6-38.8 35.8-38.8s35.8 17.1 35.8 38.8-16.6 38.8-35.8 38.8-35.8-17.1-35.8-38.8z",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M657.8 88.8c-15.5 0-28.1 13.2-28.1 28.7V204h-26.2V67.1h26.2v12.5c7.7-9.9 19-16.5 33.8-16.5 18.4 0 32.5 9.1 40.7 23.1 9.1-13.5 23.9-23.1 41.8-23.1 29.9 0 48.5 24.1 48.6 53.9v87h-26.2v-86.6c0-15.5-12.6-28.7-28.1-28.7s-28.1 13.2-28.1 28.7V204H686v-86.6c-.1-15.5-12.7-28.6-28.2-28.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M934.4 82.6c-11.7-12.1-27.7-19.5-46.2-19.5-39 0-66.8 33.1-66.8 72.5s27.7 72.5 66.8 72.5c18.5 0 34.5-7.5 46.2-19.5V204h26.2V67.1h-26.2zm-86.7 53c0-26.1 20-46.8 43.4-46.8 23.3 0 43.4 20.6 43.4 46.8 0 26.1-20 46.8-43.4 46.8-23.4-.1-43.4-20.7-43.4-46.8z",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h176.3v264.4H0z",
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1 132.2c0-24.3 19.7-44.1 44.1-44.1 24.3 0 44.1 19.7 44.1 44.1 0 24.3-19.7 44.1-44.1 44.1-24.3 0-44.1-19.8-44.1-44.1z",
    fill: "#1abcfe"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 220.3c0-24.3 19.7-44.1 44.1-44.1h44.1v44.1c0 24.3-19.7 44.1-44.1 44.1-24.4 0-44.1-19.7-44.1-44.1z",
    fill: "#0acf83"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1 0v88.1h44.1c24.3 0 44.1-19.7 44.1-44.1 0-24.3-19.7-44.1-44.1-44.1H88.1z",
    fill: "#ff7262"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 44.1c0 24.3 19.7 44.1 44.1 44.1h44.1V0H44.1C19.7 0 0 19.7 0 44.1z",
    fill: "#f24e1e"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 132.2c0 24.3 19.7 44.1 44.1 44.1h44.1V88.1H44.1C19.7 88.1 0 107.9 0 132.2z",
    fill: "#a259ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma5);
export default __webpack_public_path__ + "static/media/figma-5.6218f83ca84bfc711b2a5db80e6753fd.svg";
export { ForwardRef as ReactComponent };